<template>
	<div id="app" class="webPage df cf">
		<!-- <app-header ref="childrenHeader"></app-header> -->

		<router-view ref="childrenRouter" />

		<!-- <app-footer-nav></app-footer-nav> -->

		<div class="load df wao hao" v-if="isShowLoad">
			<div class="loadArea">
				<div class="loadCircle"></div>
			</div>
		</div>

		<div class="kAlert df wao hao" v-if="isShowKalert">
			<div class="kAlert-box">
				<div class="kAlert-txt df wao">{{ kalertTxt }}</div>
				<div class="kAlert-end df wao hao">
					<div class="kAlert-btn" @click="closeKalert">确定</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import Vue from "vue";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
Vue.use(preview);

import inobounce from "inobounce";
import h5PowerApi from "./script/power.js";
import Watermark from "./script/watermark.js";
import h5LegalApi from "./script/legal.js";

var kalertGroup = []; // 弹框队列
export default {
	name: "app",
	data() {
		return {
			isShowLoad: false,
			isShowKalert: false,
			kalertTxt: "",
			isShowLegalAlert: false,
			legalAlertContent: "",
			legalClockNumber: 10,
			legalRead: false,
			legalError: "",
			role: "",
			h5Role: ""
		};
	},
	mounted() {
		// 展示 问卷页面
		if(window.location.href.includes('/project/form/view')){
			/* console.log(window.location)
			console.log(window.location.href.includes('/project/form/view')) */
			let key = window.location.search && window.location.search.split('=')[1];
			// console.log(key)
			this.$router.push({
				path: '/project/form/view',
				query: {
					key
				}
			})
		}
		// 填写 问卷
		if(window.location.href.includes('/s')){
			console.log(window.location)
			console.log('write')
			this.$router.push(window.location.pathname);
		}


		function setRemFontSize() {
			let remSize = window.innerWidth / 3.75;
			document.querySelector("html").style.fontSize = remSize + "px";
		}
		setRemFontSize();
		window.addEventListener("resize", function() {
			setTimeout(function() {
				setRemFontSize();
			}, 200);
		});

		var that = this;
		window.h5ShowLoad = function() {
			that.isShowLoad = true;
		};
		window.h5CloseLoad = function() {
			that.isShowLoad = false;
		};
		window.alert = function(txt) {
			if (that.isShowKalert == true) {
				kalertGroup.push(txt);
				return;
			}
			that.kalertTxt = txt;
			that.isShowKalert = true;
		};
		window.showLegalAlert = function() {
			clearInterval(window.legalClock);
			that.legalClockNumber = 10;
			that.isShowLegalAlert = true;
			window.legalClock = setInterval(r => {
				if (that.legalClockNumber == 1) {
					if (!that.legalRead) {
						that.legalError = "请滚动到底部";
					}
					clearInterval(window.legalClock);
				}
				that.legalClockNumber--;
			}, 1000);
		};

		// 设置水印
		this.h5Ajax("get", "$/user/info", {
			page: this.pagenum_manualCheck,
			size: this.pagesize_manualCheck
		})
			.then(r => {
				let number = r.staffNo;
				Watermark.set(number);
				var roles = {
					vacationer: "游客",
					dealer: "经销商",
					counselor: "辅导员",
					teacher: "培训中心老师",
					administrator: "超级管理员"
				};
				that.h5Role = roles[r.roles];
				if (r.declaration == 0) showLegalAlert();
			})
			.catch(err => {
				console.error("err:" + err);
			});
	},
	created() {
		let p = navigator.platform;
		if (p != "Win32") {
			let u = navigator.userAgent;
			if (u.indexOf("iPhone") > -1) {
				inobounce.enable();
			}
		}
	},
	beforeDestroy() {
		inobounce.disable();
	},
	methods: {
		changeModelReleasePrivate(state) {
			this.$refs["childrenRouter"].changeModelReleasePrivate(state);
		},
		submitModelRelease() {
			this.$refs["childrenRouter"].submitModelRelease();
		},
		hideModelRelease() {
			this.$refs["childrenHeader"].hideModelRelease();
		},
		listenScrollLegal(e) {
			//监听滚动
			let ele = e.srcElement ? e.srcElement : e.target;
			if (ele.scrollTop + ele.offsetHeight > ele.scrollHeight - 10) {
				this.legalRead = true;
				this.legalError = "";
			} else {
				this.legalRead = false;
			}
		},
		closeKalert() {
			this.kalertTxt = "";
			this.isShowKalert = false;

			setTimeout(r => {
				if (kalertGroup.length > 0) {
					var txt = kalertGroup[0];
					kalertGroup.splice(0, 1);
					alert(txt);
				}
			}, 200);
		},
		closeLegalAlert() {
			this.legalError = "";
			if (this.legalClockNumber != 0) {
				// this.legalError = '请认真阅读10秒后才可点击同意';
			} else if (!this.legalRead) {
				this.legalError = "没有滚动到底部";
			} else {
				h5LegalApi.agree(r => {
					this.isShowLegalAlert = false;
				});
			}
		}
	}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/app/index.vue